<template>
  <base-warning v-model="modelValue">
    <div class="d-flex flex-column gap-1 font-size-14">
      <p>Atenção</p>
      <p>
        Para solicitar esse medicamento <span class="font-weight-bold"> via SUS</span>, atente-se para às seguintes
        exigências:
      </p>
      <ul>
        <li>Idade mínima <span class="font-weight-bold"> 18 anos</span>;</li>
        <li>
          Relatório médico / anamnese constando informação de pelo menos,
          <span class="font-weight-bold"> uma exacerbação grave </span> no ano anterior com necessidade de curso de
          corticoide oral;
        </li>
        <li>
          <span class="font-weight-bold"> Eosinófilos </span> no sangue periférico
          <span class="font-weight-bold"> acima de 300 células/μl</span>;
        </li>
        <li><span class="font-weight-bold"> Espirometria</span>.</li>
      </ul>
      <p>
        Para solicitar esse medicamento via <span class="font-weight-bold">OPERADORA DE SAÚDE</span>, atente-se para às
        seguintes exigências:
      </p>
      <div v-html="asthmaRequirements['asma-eosinofilica-grave']" />
    </div>
  </base-warning>
</template>

<script>
import { ComputedOptions } from 'vue'
import BaseWarning from '../BaseWarning.vue'
import asthmaRequirements from './helper/commonRequirements'

export default {
  components: { BaseWarning },
  name: 'ConductWarning.Mepolizumabe100',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asthmaRequirements,
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
